(function(){
  var root=document.documentElement;
  function $(s,c){return (c||document).querySelector(s)}
  function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}
  function clamp(x,a,b){return Math.min(b,Math.max(a,x))}

  var NAMES={black:'#222222',red:'#c1121f',maroon:'#7a1f2b',burgundy:'#7a1f2b',wine:'#7a1f2b',pink:'#e0568c',rose:'#d6577a',purple:'#6d3fc0',violet:'#7a4fd0',lavender:'#8e6fc5',blue:'#1f6fd1',navy:'#1d3557',sky:'#3d8fd6',teal:'#0f8b8d',turquoise:'#12a1a3',cyan:'#0f9fb5',green:'#1f9d55',olive:'#6b7d2a',mint:'#2fa88a',yellow:'#c99a06',gold:'#b8891a',orange:'#e0661a',brown:'#7a4a2b',coffee:'#6f4a34',khaki:'#a8845a',beige:'#a8845a',cream:'#a8845a',camel:'#a8703a',grey:'#5b6470',gray:'#5b6470',silver:'#6b7280',white:'#2b2b2b',
    'احمر':'#c1121f','أحمر':'#c1121f','ازرق':'#1f6fd1','أزرق':'#1f6fd1','اخضر':'#1f9d55','أخضر':'#1f9d55','اسود':'#222222','أسود':'#222222','ابيض':'#2b2b2b','أبيض':'#2b2b2b','وردي':'#e0568c','بنفسجي':'#6d3fc0','اصفر':'#c99a06','أصفر':'#c99a06','برتقالي':'#e0661a','بني':'#7a4a2b','رمادي':'#5b6470','ذهبي':'#b8891a','فضي':'#6b7280'};

  function colorFromText(v){
    var t=String(v).toLowerCase().split(/[^a-z\u0600-\u06ff]+/);
    for(var i=0;i<t.length;i++){
      if(!t[i])continue;
      if(NAMES[t[i]])return NAMES[t[i]];
      for(var k in NAMES){
        if(k.length>=5&&/^[a-z]+$/.test(k)&&t[i].length>k.length&&t[i].slice(-k.length)===k)return NAMES[k];
      }
    }
    return null;
  }
  function hexRgb(h){h=h.replace('#','');return [parseInt(h.substr(0,2),16),parseInt(h.substr(2,2),16),parseInt(h.substr(4,2),16)]}
  function rgbHsl(r,g,b){r/=255;g/=255;b/=255;var mx=Math.max(r,g,b),mn=Math.min(r,g,b),l=(mx+mn)/2,h=0,s=0,d=mx-mn;if(d){s=l>.5?d/(2-mx-mn):d/(mx+mn);if(mx===r)h=(g-b)/d+(g<b?6:0);else if(mx===g)h=(b-r)/d+2;else h=(r-g)/d+4;h*=60}return [h,s,l]}
  function css(h,s,l){return 'hsl('+Math.round(h)+','+Math.round(s*100)+'%,'+Math.round(l*100)+'%)'}

  function applyTheme(h,s){
    var neutral=s<.2, st=root.style;
    if(neutral){h=220}
    var aS=neutral?.1:clamp(s,.5,.85);
    var aL=(h>35&&h<70)?.3:(neutral?.16:.36);
    st.setProperty('--tz-accent',css(h,aS,aL));
    st.setProperty('--tz-accent-dark',css(h,aS,Math.max(.1,aL-.12)));
    st.setProperty('--tz-tint',css(h,neutral?.06:.55,.965));
    st.setProperty('--tz-soft',css(h,neutral?.05:.45,.925));
    st.setProperty('--tz-line',css(h,neutral?.06:.3,.85));
    st.setProperty('--tz-ink',css(h,neutral?.1:.35,.08));
    var m=$('meta[name=theme-color]');if(m){m.setAttribute('content',css(h,aS,aL))}
  }
  function themeFromHex(hex){var c=hexRgb(hex),x=rgbHsl(c[0],c[1],c[2]);applyTheme(x[0],x[1])}

  function fromImage(url,done){
    var img=new Image();img.crossOrigin='anonymous';
    img.onload=function(){
      try{
        var S=64,c=document.createElement('canvas');c.width=c.height=S;
        var g=c.getContext('2d');g.drawImage(img,0,0,S,S);
        var d=g.getImageData(0,0,S,S).data,bins={};
        for(var i=0;i<d.length;i+=4){
          if(d[i+3]<200)continue;
          var x=rgbHsl(d[i],d[i+1],d[i+2]);
          if(x[2]>.93)continue;
          if(x[1]<.22)continue;
          var k=Math.round(x[0]/20)%18,w=x[1]*(1-Math.abs(x[2]-.5));
          var b=bins[k]||(bins[k]={w:0,s:0,hx:0,hy:0});
          b.w+=w;b.s+=x[1]*w;b.hx+=Math.cos(x[0]*Math.PI/180)*w;b.hy+=Math.sin(x[0]*Math.PI/180)*w;
        }
        var best=null;for(var key in bins){if(!best||bins[key].w>best.w)best=bins[key]}
        if(best&&best.w>3){
          var hue=Math.atan2(best.hy,best.hx)*180/Math.PI;if(hue<0)hue+=360;
          done(hue,best.s/best.w);return;
        }
        done(220,0);
      }catch(e){done(null,null)}
    };
    img.onerror=function(){done(null,null)};
    img.src=url;
  }

  var variants=[],baseImg='';
  function loadVariants(){
    var el=$('#tz-variants');
    if(!el)return false;
    try{variants=JSON.parse(el.textContent)}catch(e){variants=[]}
    baseImg=el.getAttribute('data-image')||'';
    return true;
  }
  function selected(){
    var out=[];
    $$('product-info variant-selects input[type=radio]:checked').forEach(function(i){out.push(i.value)});
    $$('product-info variant-selects select').forEach(function(s){out.push(s.value)});
    return out;
  }
  function currentVariant(){
    var sel=selected();
    for(var i=0;i<variants.length;i++){
      var o=variants[i].options||[],ok=sel.length>0&&o.length===sel.length;
      for(var j=0;ok&&j<o.length;j++){if(o[j]!==sel[j])ok=false}
      if(ok)return variants[i];
    }
    return variants[0]||null;
  }
  function withW(u){return u+(u.indexOf('?')>-1?'&':'?')+'width=160'}
  var lastKey='';
  function updateTheme(){
    var sel=selected(),hex=null;
    sel.forEach(function(v){if(!hex)hex=colorFromText(v)});
    var v=currentVariant(),img=(v&&v.featured_image&&v.featured_image.src)||baseImg;
    var key=(hex||'')+'|'+img;if(key===lastKey)return;lastKey=key;
    if(hex){themeFromHex(hex);return}
    if(img){fromImage(withW(img),function(h,s){if(h!==null)applyTheme(h,s)})}
  }

  function parseMoney(str){
    var m=str.match(/\d[\d.,\s\u00a0]*\d|\d/);if(!m)return null;
    var raw=m[0].replace(/[\s\u00a0]/g,''),last=Math.max(raw.lastIndexOf('.'),raw.lastIndexOf(',')),dec='',frac='',n;
    if(last>-1&&raw.length-last-1<=2){dec=raw.charAt(last);frac=raw.slice(last+1);n=parseFloat(raw.slice(0,last).replace(/\D/g,'')+'.'+frac)}
    else{n=parseFloat(raw.replace(/\D/g,''))}
    return {n:n,tpl:str,raw:m[0],dec:dec,places:frac.length,group:(dec==='.'?(raw.indexOf(',')>-1?',':''):(raw.indexOf('.')>-1?'.':''))};
  }
  function fmt(p,n){
    var s=n.toFixed(p.places),parts=s.split('.');
    if(p.group){parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,p.group)}
    var out=parts[0]+(parts[1]?(p.dec||'.')+parts[1]:'');
    return p.tpl.replace(p.raw,out);
  }
  function unitPrices(){
    var box=$('product-info .price');if(!box)return null;
    var last=$('.price-item--last',box),cmp=$('.price__sale .price-item--regular',box);
    if(!last)return null;
    var u=parseMoney(last.textContent.trim());if(!u)return null;
    var c=(box.classList.contains('price--on-sale')&&cmp)?parseMoney(cmp.textContent.trim()):null;
    return {u:u,c:c};
  }

  var activeQty=1;
  function setQty(q){
    activeQty=q;
    var inp=$('product-info input.quantity__input');
    if(inp&&String(inp.value)!==String(q)){inp.value=q;inp.dispatchEvent(new Event('change',{bubbles:true}))}
  }
  function renderTiers(){
    var P=unitPrices();if(!P)return;
    var wrap=$('.tz-bundles'),free=wrap?+wrap.getAttribute('data-free'):0;
    var sameCur=wrap&&wrap.getAttribute('data-currency')===wrap.getAttribute('data-shop-currency');
    $$('.tz-tier').forEach(function(t){
      var q=+t.getAttribute('data-qty');
      var total=P.u.n*q,cmp=(P.c?P.c.n:P.u.n)*q;
      $('.tz-tier__now',t).textContent=fmt(P.u,total);
      var old=$('.tz-tier__old',t),sv=$('.tz-tier__save',t),sh=$('.tz-tier__ship',t);
      if(cmp>total+.005){old.textContent=fmt(P.u,cmp);old.style.display='';sv.textContent='You save '+fmt(P.u,cmp-total);sv.style.display=''}
      else{old.style.display='none';sv.style.display='none'}
      if(sh){sh.textContent='Free shipping';sh.style.display=(sameCur&&free>0&&total>=free)?'':'none'}
    });
    var sp=$('.tz-sticky__p');if(sp)sp.textContent=fmt(P.u,P.u.n);
  }
  function initTiers(){
    $$('.tz-tier').forEach(function(t){
      t.addEventListener('click',function(){
        $$('.tz-tier').forEach(function(x){x.classList.remove('is-active')});
        t.classList.add('is-active');setQty(+t.getAttribute('data-qty'));
      });
    });
    renderTiers();
  }

  function ord(n){var s=['th','st','nd','rd'],v=n%100;return n+(s[(v-20)%10]||s[v]||s[0])}
  function dateLabel(d){
    var lang=(document.documentElement.lang||'en').toLowerCase();
    if(lang.indexOf('en')===0){return d.toLocaleDateString('en',{month:'short'})+' '+ord(d.getDate())}
    return d.toLocaleDateString(lang,{month:'short',day:'numeric'});
  }
  function addBiz(n){var d=new Date(),c=0;while(c<n){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)c++}return d}
  function initTimeline(){
    $$('.tz-steps').forEach(function(w){
      var rMin=+w.getAttribute('data-ready-min'),rMax=+w.getAttribute('data-ready-max'),dMin=+w.getAttribute('data-del-min'),dMax=+w.getAttribute('data-del-max');
      var a=$('[data-s=ordered]',w),b=$('[data-s=ready]',w),c=$('[data-s=delivered]',w);
      if(a)a.textContent=dateLabel(new Date());
      if(b)b.textContent=dateLabel(addBiz(rMin))+' - '+dateLabel(addBiz(rMax));
      if(c)c.textContent=dateLabel(addBiz(dMin))+' - '+dateLabel(addBiz(dMax));
    });
  }

  function initFloating(){
    $$('body > .tz-sticky,body > .tz-top').forEach(function(e){e.remove()});
    var st=$('product-info .tz-sticky'),tp=$('product-info .tz-top');
    if(st)document.body.appendChild(st);
    if(tp)document.body.appendChild(tp);
    st=$('body > .tz-sticky');tp=$('body > .tz-top');
    var btn=$('product-info .product-form__submit');
    if(st){
      var b=$('.tz-sticky__b',st);
      if(b)b.addEventListener('click',function(){var x=$('product-info .product-form__submit');if(x)x.click()});
    }
    if(tp)tp.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})});
    var inView=true;
    function sync(){
      var y=window.scrollY||0;
      if(st){var on=!inView&&y>300;st.classList.toggle('is-on',on);document.body.classList.toggle('tz-has-sticky',on)}
      if(tp)tp.classList.toggle('is-on',y>700);
    }
    if(btn&&'IntersectionObserver' in window){
      new IntersectionObserver(function(e){inView=e[0].isIntersecting;sync()}).observe(btn);
    }
    window.addEventListener('scroll',sync,{passive:true});sync();
  }

  function afterVariant(){updateTheme();renderTiers();setQty(activeQty)}
  function init(){
    if(!loadVariants())return;
    updateTheme();initTiers();initTimeline();initFloating();
  }
  document.addEventListener('change',function(e){
    if(e.target&&e.target.closest&&e.target.closest('variant-selects')){setTimeout(afterVariant,300);setTimeout(afterVariant,1000)}
  });
  document.addEventListener('shopify:section:load',function(){activeQty=1;lastKey='';setTimeout(init,50)});
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();